/* import __COLOCATED_TEMPLATE__ from './comment-tag.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();